export default {
  computed: {
    isProduction() {
      return process.env.NODE_ENV === 'production'
    },
  },
}
